import { useEffect, useState, type ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Tooltip de los iconos de acción de las tablas. Mismo comportamiento que el de
 * portal-cobranza: nada de `title` nativo, popup consistente en todos los portales.
 * Requiere un `TooltipProvider` arriba (ya está en App.tsx). Ancho acotado y margen contra las
 * orillas de la ventana para que un texto largo nunca se salga de la pantalla.
 *
 * `oculto`: mientras sea true el tooltip no se muestra (p. ej. el "..." con su menú abierto: el
 * menú ya dice qué hay y el tooltip quedaba encima de los ítems). Un tooltip solo va donde no hay
 * texto visible (botón de solo ícono, texto recortado).
 */
export function IconTip({
  label,
  children,
  side = "top",
  oculto = false,
}: {
  label: string;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  oculto?: boolean;
}) {
  const [abierto, setAbierto] = useState(false);
  // Al ocultarse se olvida lo pendiente: el retardo de apertura (150 ms) podía disparar justo
  // después del clic que abrió el menú y el tooltip reaparecía al cerrarlo.
  useEffect(() => { if (oculto) setAbierto(false); }, [oculto]);
  return (
    <Tooltip delayDuration={150} open={!oculto && abierto} onOpenChange={(v) => setAbierto(oculto ? false : v)}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} collisionPadding={12} className="max-w-[min(280px,calc(100vw-24px))] text-[11px] leading-snug">
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
